export default __webpack_public_path__ + "static/media/s2.3260a3b5.jpg";